import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterTag_template} from "./filterTag_template";
import {filterArticle_template} from "./filterArticle_template";


declare var ko: any;

export class configCategoriesTagPinEdit_template extends vnTemplate{

    protected getTemplateHtml(): string{
        return `
        

            <div class="form-header" data-bind="with: category">
                <input type="hidden">

                <h3 class="form-title icon i-tag" data-bind="text: name + ' - Pinned Tags'"></h3>
                <button data-bind="event: { click: $parent.onClickCancelPinnedTags }" class="close-button icon i-close-2" type="button"></button>

            </div> 
            
             <div class="form-w-btn" data-bind="with: category">
                <button data-bind="event: { click: $parent.onClickAddPinnedTag }, text: 'Add Tag to : ' + name " class="btn secondary icon i-add" type="button"></button>
             </div>
             
            
             <!-- ko if: pinnedTags().length > 0-->
                <div class="form-body" data-bind="foreach: pinnedTags">

                    <!-- ko if: idTag  == null -->
                    <div class="form-group cleared">
                        <label data-bind="text: 'Position ' + ($index() + 1)" for="" class="form-label"></label>
                        
                            <div data-bind="template: { name: 'filterTag-template', data: $data.tagFilter.getTemplateViewModel() }"></div>
                    </div>
                    <!-- /ko -->
                   
                    
                    <!-- ko ifnot: idTag == null -->
                    <div class="form-group row">
                        <div class="row">
                            <label data-bind="text: 'Position ' + ($index() + 1)" for="" class="form-label"></label>
                            <span data-bind="text: tag.name + ' (' + tag.slug + ')'" class="form-tags"></span>
                        </div>
                        <div class="row">
                            <button data-bind="event: { click: $parent.onClickEditPinnedTag }" class="btn icon small border only-icon i-edit" type="button"></button>
                            <button data-bind="event: { click: $parent.onClickDeletePinnedTag.bind($data, $index())}" class="btn highlight small only-icon icon i-delete" type="button"></button>
                        </div>
                    </div>
                    <!-- /ko -->
                    
                </div> 
            <!-- /ko -->​
                

            <!-- ko if: pinnedTags().length == 0-->
                <div>
                    There are no tag preview widgets pinned to the category
                </div>
            <!-- /ko -->​
                
                
            
            <div class="form-footer">                
                <button data-bind="event: { click: onClickCancelPinnedTags }" title="There will be no changes made"  class="btn " type="button">Cancel</button>
                <button data-bind="event: { click: onClickSavePinnedTags }" class="btn highlight" type="button">Save Pinned Tags</button>            
            </div>
    
           
        `;

    }

    protected getTemplateName(): string{
        return "configCategoriesTagPinEdit-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string> {

        return ["w-form", "pinned-tags"];
    }

    protected buildViewModel(): any{

        let huit_neuf_this = this;
        return  {
            category: ko.observable()
            ,pinnedTags: ko.observableArray([])
            ,pinnedTagsIndex: ko.observable(0)
            ,onClickAddPinnedTag: function (data, event) {
                huit_neuf_this.onClickAddPinnedTag();
            }
            ,onClickEditPinnedTag: function (data, event) {
                huit_neuf_this.onClickEditPinnedTag(data);
            }
            ,onClickDeletePinnedTag: function (value) {
                huit_neuf_this.onClickDeletePinnedTag(value);
            }
            ,onClickCancelPinnedTags: function (data, event) {
                huit_neuf_this.onClickCancelPinnedTags();
            }
            ,onClickSavePinnedTags: function (data, event) {
                huit_neuf_this.onClickSavePinnedTags();
            }
        };
    }

    public setCategory(category) {

        this.getTemplateViewModel().category(category);
    }

    public setPinnedTags(pinnedTags) {

        let x = [];
        for (let p of pinnedTags) {
            p.tagFilter = new filterTag_template("filterTag"+(this.getTemplateViewModel().pinnedTagsIndex()), this.getTemplateViewModel(), this.caller);
            p.index = this.getTemplateViewModel().pinnedTagsIndex();
            this.getTemplateViewModel().pinnedTagsIndex(this.getTemplateViewModel().pinnedTagsIndex()+1);
            x.push(p);
        }

        this.getTemplateViewModel().pinnedTags(x);

    }

    protected onClickAddPinnedTag() {

        this.getTemplateViewModel().pinnedTags.push({
            idTag: null,
            tag: null,
            tagFilter: new filterTag_template("filterTag"+(this.getTemplateViewModel().pinnedTagsIndex()), this.getTemplateViewModel(), this.caller),
            index: this.getTemplateViewModel().pinnedTagsIndex()
        });

        this.getTemplateViewModel().pinnedTagsIndex(this.getTemplateViewModel().pinnedTagsIndex()+1);
    }


    protected onClickEditPinnedTag(data) {

        data.idTag = null;
        data.tag = null;
        data.tagFilter.getTemplateViewModel().tag("");

        let x = this.getTemplateViewModel().pinnedTags();

        this.getTemplateViewModel().pinnedTags([]);
        this.getTemplateViewModel().pinnedTags(x);
    }

    protected onClickDeletePinnedTag(index) {

        let x = this.getTemplateViewModel().pinnedTags();
        if (index !== -1) {
            x.splice(index, 1);
        }

        this.getTemplateViewModel().pinnedTags(x);
    }


    protected setFilterAutocomplete(idElement, tags) {

        let index = idElement.replace('filterTag','');
        let pinned = this.getTemplateViewModel().pinnedTags();

        let currSearch = pinned.find(p => p.index == index);
        currSearch.tagFilter.getTemplateViewModel().tags(tags);
    }


    public setPinnedTag(idElement) {

        let index = idElement.replace('filterTag','');
        let allPinned = this.getTemplateViewModel().pinnedTags();

        let pinned = allPinned.find(p => p.index == index);

        let chosenTag = pinned.tagFilter.getTemplateViewModel().tagObj();

        pinned.idTag = chosenTag.id;
        pinned.tag = chosenTag;

        this.getTemplateViewModel().pinnedTags([]);
        this.getTemplateViewModel().pinnedTags(allPinned);
    }

    protected onClickCancelPinnedTags() {

        this.caller.cancelPinnedTags();
    }

    protected onClickSavePinnedTags() {

        let x = this.getTemplateViewModel().pinnedTags();
        let y = [];
        for (let p of x) {
            if (p.idTag != undefined) {
                y.push(p);
            }
        }

        this.getTemplateViewModel().pinnedTags(y);

        this.caller.savePinnedTags();
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/configCategoriesTagPinEdit_template.ts